(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-chill-elegear-h5"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const initialize = (root) => {
    if (!root || root.dataset.arcChillInitialized === "true") return;
    root.dataset.arcChillInitialized = "true";
    root.classList.add("has-js");

    root.querySelectorAll("[data-tech-rail]").forEach((rail) => {
      rail.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
        if (rail.scrollWidth <= rail.clientWidth) return;
        const direction = event.key === "ArrowRight" ? 1 : -1;
        rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: reduceMotion ? "auto" : "smooth" });
      });
    });

    const nodes = Array.from(root.querySelectorAll("[data-reveal]"));
    if (!("IntersectionObserver" in window) || reduceMotion) {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    nodes.forEach((node) => observer.observe(node));
  };

  const initializeAll = (scope = document) => scope.querySelectorAll("[data-arc-chill-native]").forEach(initialize);
  initializeAll();
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
